import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.scss']
})

/**
 * Collection Component
 */
export class CollectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
